import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52af0e4c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "add_task" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1))
const _hoisted_3 = { class: "flexAlign" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "d" }, "*"),
  /*#__PURE__*/_createTextVNode("编号")
], -1))
const _hoisted_5 = { class: "right" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1))
const _hoisted_7 = { class: "flexAlign" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "d" }, "*"),
  /*#__PURE__*/_createTextVNode("名称")
], -1))
const _hoisted_9 = { class: "right" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1))
const _hoisted_11 = { class: "flexAlign" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "d" }, "*"),
  /*#__PURE__*/_createTextVNode("分类")
], -1))
const _hoisted_13 = { class: "right" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1))
const _hoisted_15 = { style: {"width":"150px","float":"left"} }
const _hoisted_16 = { style: {"margin-top":"10px"} }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" cad照片: ")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("上传文件")
const _hoisted_19 = ["href"]
const _hoisted_20 = ["src"]
const _hoisted_21 = { style: {"width":"150px","float":"left"} }
const _hoisted_22 = { style: {"margin-top":"10px"} }
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" cad文件: ")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("上传文件")
const _hoisted_25 = ["href"]
const _hoisted_26 = { style: {"width":"150px","float":"left"} }
const _hoisted_27 = { style: {"margin-top":"10px"} }
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" 公式文件: ")
const _hoisted_29 = /*#__PURE__*/_createTextVNode("上传文件")
const _hoisted_30 = ["href"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1))
const _hoisted_33 = { class: "flexAlign" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, "备注", -1))
const _hoisted_35 = { class: "right" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1))
const _hoisted_37 = { class: "flexCenter" }
const _hoisted_38 = /*#__PURE__*/_createTextVNode("提 交")

import { ref,onMounted } from 'vue';
	import { requestModelingedit,requestModelingfindbyid } from '@/api/xmApi';
	import { apiName,requestMyuser,requestZtreeModelingPath } from '@/api/api';
	import { ElMessage } from 'element-plus';
	import {
        requestGetAllConfig
    } from '@/api/configApi.js';
	import type { UploadUserFile } from 'element-plus'
	
export default /*#__PURE__*/_defineComponent({
  name: 'jianmoDetails',
  props: {
		form:{
			type: Number,
			default: 0
		},
	},
  emits: ['cancelTask'],
  setup(__props, { emit }) {

const props = __props

	const fileList = ref<UploadUserFile[]>([])
	
	const api = ref<string>(apiName)
	const apiname = ref<string>(apiName)
	
	const form = ref<any>({
			cadimg:[],
			cadfile:[],
			gsfile:[],
	})
	const modelingpathLists = ref<any[]>([])
	const projectinfotype1= ref<string>("")
	const projectinfo = ref({type1:''})
	const zxr = ref<string>("")//执行人
	const shr = ref<string>("")//审核人
	// 获取全部人员命名
	const userLists = ref<any[]>([])
	const sxlxLists = ref<any[]>([])
	const type2Lists = ref<any[]>([])
	const jmlxLists = ref<any[]>([])
	//提交
	const submit = () => {
		console.log("1234")
		console.log(form)
		console.log(form.value)
		console.log(form.value.cadimg)
		console.log(form.cadimg)
		console.log("123")
		var cadimgurl=''
		if(form.value.cadimg.length > 0){
				var tmpurl=new Array();
				for(var j = 0; j < form.value.cadimg.length; j++){
					tmpurl.push(form.value.cadimg[j].response.data[0].url)
				}
				console.log(tmpurl);
				cadimgurl=tmpurl.join(",");
			}else{
				cadimgurl="";
			}
		var	cadfileurl=''
		if(form.value.cadfile.length > 0){
				var tmpurl=new Array();
				for(var j = 0; j < form.value.cadfile.length; j++){
					tmpurl.push(form.value.cadfile[j].response.data[0].url)
				}
				console.log(tmpurl);
				cadfileurl=tmpurl.join(",");
			}else{
				cadfileurl="";
			}
			var gsfileurl='';
			if(form.value.gsfile.length > 0){
				var tmpurl=new Array();
				for(var j = 0; j < form.value.gsfile.length; j++){
					tmpurl.push(form.value.gsfile[j].response.data[0].url)
				}
				console.log(tmpurl);
				gsfileurl=tmpurl.join(",");
			}else{
				gsfileurl="";
			}
		requestModelingedit({
			id:props.form,
			taskid:form.value.taskid,
			code:form.value.code,
			name:form.value.name,
			typeid:form.value.typeid,
			cadimg:cadimgurl,
			cadfile:cadfileurl,
			gsfile:gsfileurl,
			remarks:form.value.remarks
		}).then((res:any)=>{
			ElMessage({
				message: res.msg,
				type: 'success',
				duration: 500
			});
			setTimeout(()=>{
				emit("taskListsx",1)
			},500)
		})
			/**/
	}
	const cancel = () => {
		emit("taskListsx")
	}
	onMounted(()=>{
		requestZtreeModelingPath().then((res:any)=>{
			modelingpathLists.value = res.datalist
		})
		console.log("1233333");
		console.log(props.form)
		console.log("12333334");
		if(props.form!='0'){
			GetxmDetails2();
		}
		
	})
	const GetxmDetails2 = () => {
        requestModelingfindbyid({
            id:props.form
        }).then((res:any)=>{
            if(res.status === 1){
            	console.log(res.datalist);
            	if( res.datalist.length!=0){
            		form.value = res.datalist
					form.value.typeid = res.datalist.typeid+'###'+res.datalist.typename
					var tmp=res.datalist;
					var cadimg1=[];
					if(tmp["cadimg"]!=""){ 
						for(var j=0;j<tmp["cadimg"].split(",").length;j++){
							cadimg1.push({response:{data:[{url:tmp["cadimg"].split(",")[j]}]}})
						}
					}
					var cadfile1=[];
					if(tmp["cadfile"]!=""){ 
						for(var j=0;j<tmp["cadfile"].split(",").length;j++){
							cadfile1.push({response:{data:[{url:tmp["cadfile"].split(",")[j]}]}})
						}
					}
					var gsfile1=[];
					if(tmp["gsfile"]!=""){ 
						for(var j=0;j<tmp["gsfile"].split(",").length;j++){
							gsfile1.push({response:{data:[{url:tmp["gsfile"].split(",")[j]}]}})
						}
					}
					form.value.cadimg = cadimg1;
					form.value.cadfile = cadfile1;
					form.value.gsfile = gsfile1;
				}
            }
        })
    }
	const getSxlx = () => {
		console.log("sxlx");
        requestGetAllConfig({
            type:"事项类型"
        }).then((res:any)=>{
            if(res.status === 1){
            	console.log(res.datalist);
                sxlxLists.value = res.datalist
            }
        })
		requestGetAllConfig({
            type:"建模分类"
        }).then((res:any)=>{
            if(res.status === 1){
            	console.log(res.datalist);
                jmlxLists.value = res.datalist
            }
        })
		
		
    }
    const gettype2list  = () => {
		console.log("sxlx");
        requestGetAllConfig({
            type:"tasktype2"
        }).then((res:any)=>{
            if(res.status === 1){
            	console.log(res.datalist);
                type2Lists.value = res.datalist
            }
        })
    }
    

	const getDate = () => {
		// 今天的日期
		let date = new Date();
		let YY = date.getFullYear() + '-';
		let MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
		let DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
		form.value.startdate = `${YY}${MM}${DD}`
		//明天的日期
		let finalDate = new Date(date)
		let nextDate = new Date(finalDate.setDate(date.getDate() + 1))
		let nextYY = nextDate.getFullYear() + '-';
		let nextMM = (nextDate.getMonth() + 1 < 10 ? '0' + (nextDate.getMonth() + 1) : nextDate.getMonth() + 1) + '-';
		let nextDD = (nextDate.getDate() < 10 ? '0' + (nextDate.getDate()) : nextDate.getDate());
		form.value.enddate = `${nextYY}${nextMM}${nextDD}`
	}
	

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_Document = _resolveComponent("Document")!
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_el_input, {
          modelValue: form.value.code,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.code) = $event)),
          placeholder: "请输入编号"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _hoisted_6,
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_el_input, {
          modelValue: form.value.name,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.name) = $event)),
          placeholder: "请输入名称"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _hoisted_10,
    _createElementVNode("div", _hoisted_11, [
      _hoisted_12,
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_el_select, {
          filterable: "",
          modelValue: form.value.typeid,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.typeid) = $event)),
          placeholder: "请选择",
          style: {"width":"300px","margin-top":"10px"}
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(modelingpathLists.value, (item, index) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                label: item.allname,
                value: `${item.allid}###${item.allname}`,
                key: index
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    _hoisted_14,
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _hoisted_17,
        _createVNode(_component_el_upload, {
          action: `${apiname.value}/frame/uploadfile1`,
          "file-list": form.value.cadimg
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              size: "small"
            }, {
              default: _withCtx(() => [
                _hoisted_18
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["action", "file-list"]),
        _createElementVNode("div", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.value.cadimg, (v, i) => {
            return (_openBlock(), _createElementBlock("a", {
              href: `${apiname.value}${v.response.data[0].url}`,
              target: "_blank",
              key: i,
              style: {"margin-right":"10px"}
            }, [
              _createElementVNode("img", {
                src: `${apiname.value}${v.response.data[0].url}`,
                style: {"width":"30px","height":"30px"}
              }, null, 8, _hoisted_20)
            ], 8, _hoisted_19))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("div", _hoisted_22, [
        _hoisted_23,
        _createVNode(_component_el_upload, {
          action: `${apiname.value}/frame/uploadfile1`,
          "file-list": form.value.cadfile
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              size: "small"
            }, {
              default: _withCtx(() => [
                _hoisted_24
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["action", "file-list"]),
        _createElementVNode("div", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.value.cadfile, (v, i) => {
            return (_openBlock(), _createElementBlock("a", {
              href: `${apiname.value}${v.response.data[0].url}`,
              target: "_blank",
              key: i,
              style: {"margin-right":"10px"}
            }, [
              _createVNode(_component_el_icon, {
                size: 36,
                color: "#409EFF"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Document)
                ]),
                _: 1
              })
            ], 8, _hoisted_25))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_26, [
      _createElementVNode("div", _hoisted_27, [
        _hoisted_28,
        _createVNode(_component_el_upload, {
          action: `${apiname.value}/frame/uploadfile1`,
          "file-list": form.value.gsfile
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              size: "small"
            }, {
              default: _withCtx(() => [
                _hoisted_29
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["action", "file-list"]),
        _createElementVNode("div", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.value.gsfile, (v, i) => {
            return (_openBlock(), _createElementBlock("a", {
              href: `${apiname.value}${v.response.data[0].url}`,
              target: "_blank",
              key: i,
              style: {"margin-right":"10px"}
            }, [
              _createVNode(_component_el_icon, {
                size: 36,
                color: "#409EFF"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Document)
                ]),
                _: 1
              })
            ], 8, _hoisted_30))
          }), 128))
        ])
      ])
    ]),
    _hoisted_31,
    _hoisted_32,
    _createElementVNode("div", _hoisted_33, [
      _hoisted_34,
      _createElementVNode("div", _hoisted_35, [
        _createVNode(_component_el_input, {
          modelValue: form.value.remarks,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.remarks) = $event)),
          placeholder: "请输入备注"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _hoisted_36,
    _createElementVNode("div", _hoisted_37, [
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (submit())),
        round: ""
      }, {
        default: _withCtx(() => [
          _hoisted_38
        ]),
        _: 1
      })
    ])
  ]))
}
}

})